<template>
  <div v-if="!isSelectedOptionEmpty" class="pm__price-wrapper">
    <div :class="['pm__price', {'bold': productMinPrice !=  productMaxPrice || customerDiscountVal > 0 || discountPrice != actualPrice}]">{{discountPrice}}</div>
    <div class="pm__price-seperator" v-if="customerDiscountVal > 0 && discountPrice != actualPrice">
      <span class="pm__compare-price">{{actualPrice}}</span>
      <span class="pm__price-saveText">{{youSave(actualPrice,discountPrice)}}</span>
    </div>
    <div class="pm__price-seperator" v-if="discountPrice != actualPrice && customerDiscountVal === 0">
      <span class="pm__compare-price">{{compareAtPrice}}</span>
      <span class="pm__price-saveText">{{youSave(compareAtPrice,discountPrice)}}</span>
    </div>
  </div>
</template>

<script setup>
  import { computed, toRefs, ref, onBeforeMount, onMounted, onUnmounted, watch } from 'vue';

  const props = defineProps({
    product: {
      type: Object,
      default: () => ({})
    },

    selectedFirstOption: {
      type: Object,
      default: () => ({})
    },
    
    isCartEdit: {
      type: Boolean,
      default: false,
    },
    
    cartItem: {
      type: Object,
      default: null,
    }
  })
  const {
    product,
    selectedFirstOption,
    isCartEdit,
    cartItem
  } = toRefs(props)

  var customerDiscountVal = ref(0)

  onBeforeMount(() => {
    getCustomerDiscount();
    window.addEventListener('cartItemsUpdated', getCustomerDiscount);
  })

  onUnmounted(() => {
    window.removeEventListener('cartItemsUpdated', getCustomerDiscount);
  });

  const discountPrice = computed(() => {
    return window.formattedPrice(discountPriceLogic(selectedFirstOption.value, customerDiscountVal.value))
  })

  const isSelectedOptionEmpty = computed(() => Object.keys(selectedFirstOption.value).length === 0);

   const discountPriceLogic = (data, customerDiscountAmount) => {
    if(data.compare_at_price > 0){
      if(data.compare_at_price * (1 - customerDiscountAmount) < data.price){
        return (data.compare_at_price) * (1 - customerDiscountAmount)
      }else{
        return (data.price)
      }
    }else{
      return (data.price) * (1 - customerDiscountAmount)
    }
  }

  const actualPrice = computed(() => {
    if(selectedFirstOption.value.compare_at_price > 0){
      return window.formattedPrice(selectedFirstOption.value.compare_at_price)
    }else{
      return window.formattedPrice(selectedFirstOption.value.price)
    }
  })

  const compareAtPrice = computed(() => {
    return window.formattedPrice(selectedFirstOption.value.compare_at_price)
  })

  const productMinPrice = computed(() => {
    return window.formattedPrice(product.value.min_price/100)
  })

  const productMaxPrice = computed(() => {
    return window.formattedPrice(product.value.max_price/100)
  })

  const youSave = (price,secondPrice) =>{
    var finalPrice = (parseFloat(price.replace('$', '')) - parseFloat(secondPrice.replace('$', '')))
    return finalPrice % 1 != 0 ? 'You save: $' +  finalPrice.toFixed(2) : 'You save: $' +  finalPrice
  }
  
  const getCustomerDiscount = () => {
    if (isCartEdit.value && cartItem.value) {
      // For cart edit, calculate cartItemsSubTotal (sum of all cart items before current one)
      // and use the existing getAnnualCapDetails function
      const cartItems = window.cartItems || [];
      
      // Calculate subtotal of all cart items before the current one (cart array is in reverse order)
      let cartItemsSubTotal = 0;
      const currentItemIndex = cartItems.findIndex(item => item.line === cartItem.value.line);
      
      // Since cart array is in reverse order, items after current index were added before
      cartItems.forEach((item, index) => {
        
        // Filter items based on the discount conditions
        const hasValidDiscount = item.discounts?.some(discount => {
          const validTags = ['EMP', 'PRO', 'FF'];
          return validTags.some(tag => discount.title.includes(tag)) && discount.amount > 0;
        });


        if (index > currentItemIndex && hasValidDiscount) {
          // Add the discounted price of each item multiplied by quantity
          const itemPrice = item.discounted_price || item.final_price || item.price;
          cartItemsSubTotal += itemPrice * item.quantity;
        }
      });

      console.log(cartItemsSubTotal,"cartItemsSubTotal")
      
      // Pass the calculated cartItemsSubTotal to customerDiscount function
      customerDiscountVal.value = window.customerDiscount(
        product.value.tags, 
        selectedFirstOption.value.price, 
        selectedFirstOption.value.compare_at_price, 
        window.cartItems,
        cartItemsSubTotal/100
      );

      return;
    }

    customerDiscountVal.value = window.customerDiscount(product.value.tags, selectedFirstOption.value.price, selectedFirstOption.value.compare_at_price, window.cartItems);
  };
  
  watch(selectedFirstOption, () => {
    getCustomerDiscount();
  });
</script>